var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7197 9.21967C14.0126 8.92678 14.4874 8.92678 14.7803 9.21967C15.0732 9.51256 15.0732 9.98744 14.7803 10.2803L10.2803 14.7803C9.98744 15.0732 9.51256 15.0732 9.21967 14.7803C8.92678 14.4874 8.92678 14.0126 9.21967 13.7197L13.7197 9.21967ZM17.75 2C20.0972 2 22 3.90279 22 6.25V7.25C22 15.3962 15.3962 22 7.25 22H6.25C3.90279 22 2 20.0972 2 17.75V16.75C2 8.6038 8.6038 2 16.75 2H17.75ZM20.5 6.25C20.5 4.73122 19.2688 3.5 17.75 3.5H16.75C16.3467 3.5 15.9477 3.51801 15.5536 3.55328L20.4467 8.44631C20.482 8.05225 20.5 7.65323 20.5 7.25V6.25ZM20.1533 10.2742L13.7257 3.84671C8.80386 4.9958 4.93665 8.88827 3.82414 13.8241L10.176 20.1758C15.1118 19.0633 19.0043 15.1961 20.1533 10.2742ZM3.54378 15.665C3.51478 16.0229 3.5 16.3847 3.5 16.75V17.75C3.5 19.2688 4.73122 20.5 6.25 20.5H7.25C7.61532 20.5 7.97719 20.4852 8.33504 20.4562L3.54378 15.665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 15C13.9028 15 12 16.9028 12 19.25C12 21.5972 13.9028 23.5 16.25 23.5C18.5972 23.5 20.5 21.5972 20.5 19.25C20.5 16.9028 18.5972 15 16.25 15ZM15.875 16.25C16.0648 16.25 16.2218 16.3912 16.2466 16.5741L16.25 16.625V19.25H17.875C18.082 19.25 18.25 19.418 18.25 19.625C18.25 19.8148 18.1089 19.9718 17.9258 19.9966L17.875 20H15.875C15.6853 20 15.5282 19.8589 15.5034 19.6758L15.5 19.625V16.625C15.5 16.418 15.668 16.25 15.875 16.25Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 16.25,
    width: 1,
    height: 4,
    rx: 0.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 16.25,
    width: 1,
    height: 4,
    rx: 0.5,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 19.25,
    width: 1,
    height: 3.5,
    rx: 0.5,
    transform: "rotate(90 18.75 19.25)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 19.25,
    width: 1,
    height: 3.5,
    rx: 0.5,
    transform: "rotate(90 18.75 19.25)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapIcon);
export default __webpack_public_path__ + "static/media/recap-icon.9a2475b44ac2e99f03c54391b4aaf0f2.svg";
export { ForwardRef as ReactComponent };